module.exports = __webpack_public_path__ + "static/media/ajax-Loader.09fd81f3.gif";